import StyledIcon from "../StyledIcon";

const WaUser = props => {
    return <StyledIcon width="16" height="25" viewBox="0 0 16 25" fill="none" {...props}>
        <path d="M14.2942 24.9386V14.938L1.29297 14.938V24.9386" strokeWidth="2" strokeLinejoin="round" />
        <path d="M7.43359 9.94629C9.64273 9.94629 11.4336 8.15543 11.4336 5.94629C11.4336 3.73715 9.64273 1.94629 7.43359 1.94629C5.22446 1.94629 3.43359 3.73715 3.43359 5.94629C3.43359 8.15543 5.22446 9.94629 7.43359 9.94629Z" strokeWidth="2" strokeLinejoin="round" />
    </StyledIcon>
}

export default WaUser;